import { HttpErrorResponse } from '@angular/common/http';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Ticket } from '@zero/shared/util-models';
import { TicketsApiActions, TicketsPageActions } from './ticket.actions';

export const TICKET_FEATURE_KEY = 'ticket';

export interface TicketState {
  unreadTicketsCount: number;
  unreadTicketsCountLoading: boolean;
  unreadTicketsCountInitiallyLoaded: boolean;
  tickets: Ticket[];
  ticketsLoading: boolean;
  ticketsInitiallyLoaded: boolean;
  ticketsHasNext: boolean;
  error: HttpErrorResponse | null;
}

export const initialTicketState: TicketState = {
  tickets: [],
  ticketsInitiallyLoaded: false,
  ticketsLoading: false,
  ticketsHasNext: false,
  unreadTicketsCount: 0,
  unreadTicketsCountInitiallyLoaded: false,
  unreadTicketsCountLoading: false,
  error: null,
};

export const ticketsFeature = createFeature({
  name: TICKET_FEATURE_KEY,
  reducer: createReducer(
    initialTicketState,
    on(TicketsPageActions.loadTickets, (state): TicketState => ({ ...state, error: null })),
    on(
      TicketsApiActions.loadTicketsDeprecatedSuccess,
      (state, { tickets }): TicketState => ({
        ...state,
        tickets,
        ticketsInitiallyLoaded: true,
        ticketsLoading: false,
      }),
    ),
    on(
      TicketsApiActions.loadTicketsDeprecatedFailure,
      (state, { error }): TicketState => ({ ...state, error, ticketsLoading: false, ticketsHasNext: false }),
    ),
    on(
      TicketsApiActions.loadTicketsSuccess,
      (state, { tickets, ticketsHasNext }): TicketState => ({
        ...state,
        tickets,
        ticketsHasNext,
        ticketsInitiallyLoaded: true,
        ticketsLoading: false,
      }),
    ),
    on(
      TicketsApiActions.loadTicketsFailure,
      (state, { error }): TicketState => ({ ...state, error, ticketsLoading: false, ticketsHasNext: false }),
    ),
    // load unread tickets count
    on(TicketsPageActions.loadUnreadTicketsCount, (state): TicketState => ({ ...state, error: null })),
    on(
      TicketsApiActions.loadUnreadTicketsCountSuccess,
      (state, { unreadTicketsCount }): TicketState => ({
        ...state,
        unreadTicketsCount,
        unreadTicketsCountInitiallyLoaded: true,
        error: null,
      }),
    ),
    on(
      TicketsApiActions.loadUnreadTicketsCountFailure,
      (state, { error }): TicketState => ({ ...state, error, unreadTicketsCountLoading: false }),
    ),
    // set loading
    on(TicketsPageActions.setTicketLoading, (state, { ticketsLoading }): TicketState => ({ ...state, ticketsLoading })),
  ),
});

export const {
  name,
  reducer,
  selectError,
  selectTicketState,
  selectTickets,
  selectTicketsInitiallyLoaded,
  selectTicketsLoading,
  selectUnreadTicketsCount,
  selectUnreadTicketsCountInitiallyLoaded,
  selectUnreadTicketsCountLoading,
} = ticketsFeature;
